/*Objeto que almacena la informacion de bienvenida*/
export class WelcomeDTO {

    //Constructor de la clase
    constructor(

        //Nombre completo de la persona que presenta el examen
        public fullName: string,

        //Nombre de la institucion a la que pertenece
        public institution: string,

        //codigo dane de la institucion
        public daneCode: string,

        //Modalidad a la que pertenece la persona
        public modality: string,

        //nombre del examen
        public test: string,

        //indica si se trata de una credencial de holgura
        public credentialSlack: boolean,

        //Indica el tipo de aplicacion que se presenta
        public aplicationType: string,

        //codigo saber de la institucion
        public saberCode: string,

        //Indica si se trata de una credencial de saber 359
        public credential_S359: boolean,

        //Atributo que contiene la información de identificacion del usuario
        public identificacion: string,

        //Atributo que contiene la información de mail del usuario
        public mail: string,

        //Atrinuto que contiene la informaciónd e registro del usuario.
        public registro: string,

        /**Codigo del combo asociado al usuario. */
        public idCombo: string,

        //Objeto que contiene la informacion de las sesiones del examen
        public sessions: WelcomeSession[],

        /** Almacena los tipos de item presentes en el examen */
        public tiposItem: string[],

        /**Nombre corto del test*/
        public shortName: string,

        /** Identifica si el usuario es discapacitado */
        public discapacidad: Boolean,

        /** Identifica el id de territorium */
        public idTerritorium: String,

        /** Corresponde al id del curso(supervisor) */
        public idCurso: String,

        /** Corresponde a la ciudad del usuario evaluador*/
        public ciudad: String  = ''
    ) {
    }

}

export class WelcomeSession {
    constructor(
        public name: string,
        public order: string,
        public showButton: boolean,
        public disabledButton: boolean,
        public buttonAction: string,
        public subjects: WelcomeSubject[],
        public supervised: boolean = false,
        public id: number,
    ) { }
}

class WelcomeSubject {
    constructor(
        public name: any,
        public order: string,
        public totalItems: number,
        public subjectDuration: number,
        public subjectCode: string
    ) { }
}
